import { render, staticRenderFns } from "./MinutesText.vue?vue&type=template&id=a3abcc18&"
import script from "./MinutesText.vue?vue&type=script&lang=js&"
export * from "./MinutesText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports